"use client";

import { useHovercardHeading } from "../__chunks/SNORBXW6.js";
import "../__chunks/DCBMRDNF.js";
import "../__chunks/FUHTKLDR.js";
import "../__chunks/7GRXGX7S.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-heading.tsx
var TagName = "h1";
var useMenuHeading = createHook(function useMenuHeading2(props) {
  props = useHovercardHeading(props);
  return props;
});
var MenuHeading = forwardRef(function MenuHeading2(props) {
  var htmlProps = useMenuHeading(props);
  return createElement(TagName, htmlProps);
});
export { MenuHeading, useMenuHeading };